import { loadStripe, Stripe } from "@stripe/stripe-js";

const stripePromises = new Map<string, Promise<Stripe | null>>();

export function getStripe(
  publishableKey: string,
  connectedAccountId?: string | null,
): Promise<Stripe | null> {
  const key = `${publishableKey}:${connectedAccountId ?? ""}`;
  const cached = stripePromises.get(key);
  if (cached) return cached;

  const promise = loadStripe(publishableKey, {
    stripeAccount: connectedAccountId ?? undefined,
  }).catch((error) => {
    // drop failed loads so a retry can fetch Stripe.js again
    stripePromises.delete(key);
    throw error;
  });
  stripePromises.set(key, promise);
  return promise;
}
